export default __webpack_public_path__ + "static/media/number-shine-7.85ecd6fc.svg";